<template>
  <a-modal
      :title="'Trạng thái đơn hàng ' + '(' + orderInfo.order_no +')'"
      v-model="visible"
      centered
      width="64%"
      :bodyStyle="{
        padding: '0',
        height: '80vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
      }"
  >
    <template #footer>
      <a-button @click="onClose">Thoát</a-button>
    </template>
    <div>
      <order-tracking

          :autoShow="true"
          :orderTracking="orderTracking"
          :order="orderSelected"
          ref="form_tracking"
      ></order-tracking>
    </div>
  </a-modal>
</template>

<script>
import OrderTracking from "@/pages/OrderCustomer/OrderTracking";
// import EventBus from "@/event-bus";

export default {
  props:{
    orderTracking:{
      type : Object,
      default :{}
    },
    orderInfo :{
      type:Object,
      default : {}
    },
    orderSelected: {
      type: Object,
      default: {}
    },
  },
  components:{
    OrderTracking
  },

  data(){
    return {
      visible : false
    }
  },
  methods:{
    onOpen(){
      this.visible = true;
    },
    onClose(){
      this.visible = false;
    },
  },
  created() {
    EventBus.$on('openOrderHistory',this.onOpen);
  },
  destroyed() {
    EventBus.$off('openOrderHistory',this.onOpen);

  }
}
</script>

<style scoped>

</style>